import {Box, SvgIcon} from "@mui/material";
import React from "react";

export function WeaponIcon(props) {
  return(
      <img src="/Icons/weapon.svg" alt="weapon" {...props}/>
  )
}